import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";

export class BossLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, id: string) {

        super(scene);

        this.y = GameConstants.GAME_HEIGHT - 240;

        this.scaleX = this.scene.sys.game.device.os.desktop ? 1 : GameVars.scaleX;

        const flag = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "campaign_" + (GameVars.currentMapZone + 1));
        this.add(flag);

        const title = new Phaser.GameObjects.Image(this.scene, 0, -10, "texture_atlas_1", "boss_name_" + id);
        this.add(title);

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 500 : 150,
            delay: 500
        });

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 1000 : 500,
            delay: GameVars.timeStepFactor === 1 ? 4000 : 2000,
            onComplete: () => {
                this.destroy();
            },
            onCompleteScope: this
        });
    }
}
